define([
    'module',
    'jquery',
    'config'
], function (module, $, config) {
    'use strict';

    var globals = {
        rootUrl: '',
        lang: $('html').attr('lang'),
        fbAppId: '',
        ajax_fail: function (jqXHR, textStatus, errorThrown) {
            console.error(errorThrown + "\r\n" + jqXHR.statusText + "\r\n" + jqXHR.responseText);
        },
        goToByScroll: function (selector, distance) {
            var $obj;
            distance = distance || 80;
            if (selector instanceof jQuery) {
                $obj = selector;
            } else {
                $obj = $(selector);
            }
            $('html, body').animate({scrollTop: $obj.offset().top - distance}, 'slow');
        }
    };

    if (config && config.globals) {
        $.extend(globals, config.globals);
    }

    return globals;
});
